export const VERIFICATION_CODE_LENGTH = 6;
export const RESEND_CODE_ERROR_TYPE = 'resend_code_required';
export const INCORRECT_CODE_ERROR_TYPE = 'incorrect_code';
export const INCORRECT_CODE_ERROR_MESSAGE = 'Incorrect code, please try again.';
export const RESEND_CODE_ERROR_MESSAGE =
  'Please use the "Resend Code" link below or enter your information in the form below.';
